import { useState } from 'react';

import { usePermissions } from '../../hooks/usePermissions';
import { Permission } from '../../types/permissions';

import { GiftPassCompModal } from './GiftPassCompModal';

export function GiftPassCompButton() {
  const { hasPermission } = usePermissions();
  const [open, setOpen] = useState(false);

  if (!hasPermission(Permission.ISSUE_GIFT_PASSES)) return null;

  return (
    <>
      <button type="button" className="nb-btn nb-btn-primary" onClick={() => setOpen(true)}>
        Create comp pass
      </button>
      {open && <GiftPassCompModal onClose={() => setOpen(false)} />}
    </>
  );
}
